module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vbassets/_next/static/images/Stokke-fec19eb09dbce3893a4649d4877e64c3.svg";